module.exports = __webpack_public_path__ + "static/img/bg12.5bfa7a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg12.jpg
// module id = cvGa
// module chunks = 1